export default __webpack_public_path__ + "static/media/nodejs.cccdafa9.svg";